const COUNTRIES = new Set(["england", "scotland", "wales", "uk", "united kingdom", "great britain", "gb", "britain", "northern ireland"]);
const UK_POSTCODE = /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/;

export const addressIssues = (a) => {
  const lines = [a.line1, a.line2, a.line3].map((x) => x || "");
  const city = (a.city || "").trim();
  const pc = (a.postcode || "").toUpperCase().replace(/\s+/g, "");
  const issues = [];
  if (COUNTRIES.has(city.toLowerCase())) issues.push(`\u201c${city}\u201d is a country. Enter the town or city instead`);
  else if (/\d/.test(city)) issues.push("The town or city contains numbers. Is the postcode or house number in the wrong box?");
  if (pc.length >= 5 && !UK_POSTCODE.test(pc)) issues.push(`\u201c${a.postcode}\u201d doesn't look like a UK postcode`);
  if (pc.length >= 5 && lines.some((l) => l.toUpperCase().replace(/\s+/g, "").includes(pc))) issues.push("The postcode is also typed in an address line. Keep it only in the postcode box");
  const joined = lines.flatMap((l) => l.match(/\b\d+[A-Za-z]{2,}\b/g) || []).find((t) => !/^\d+(st|nd|rd|th)$/i.test(t));
  if (joined) issues.push(`\u201c${joined}\u201d looks like a missing space between the number and the street`);
  if (!lines.some((l) => /\d/.test(l)) && lines[0] && lines[0].trim().split(/\s+/).length < 2) issues.push("Address line 1 looks incomplete. Add the house number or name and the street");
  return issues;
};
